export default __webpack_public_path__ + "static/media/bookmark-gray.a50052bd.svg";